import { ObservabilityToolType } from 'types/api/status-checks/status-check'

/*
 * The display name for non-custom tools is the same as the name we get back in `TeamExternalIntegration` except for Grafana.
 * Historically, we have only supported Grafana Cloud. We now support both Grafana Cloud and Grafana On Prem. It was decided that
 * we will keep the name as 'Grafana Cloud' in the database, but the UI will display it as 'Grafana'.
 */
export const OBSERVABILITY_TOOL_DISPLAY_NAME = {
  [ObservabilityToolType.APPDYNAMICS]: 'AppDynamics',
  [ObservabilityToolType.AWS]: 'AWS',
  [ObservabilityToolType.AZURE]: 'Azure',
  [ObservabilityToolType.CUSTOM]: 'Custom',
  [ObservabilityToolType.DATADOG]: 'Datadog',
  [ObservabilityToolType.DYNATRACE]: 'Dynatrace',
  [ObservabilityToolType.GCP]: 'GCP',
  [ObservabilityToolType.GRAFANA]: 'Grafana',
  [ObservabilityToolType.NEWRELIC]: 'New Relic',
  [ObservabilityToolType.PAGERDUTY]: 'PagerDuty',
  [ObservabilityToolType.PROMETHEUS]: 'Prometheus'
}

/*
 * Use this when we send the name to BE
 */
export const INTEGRATION_NAME = {
  ...OBSERVABILITY_TOOL_DISPLAY_NAME,
  [ObservabilityToolType.GRAFANA]: 'Grafana Cloud'
}
